import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconUser = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName, className);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 11 11"
      className={classes}
    >
      <path
        fill="currentColor"
        d="M5.48 5.5a2.76 2.76 0 0 1-2.761-2.75C2.719 1.23 3.959 0 5.48 0 7 0 8.241 1.23 8.241 2.75S7.001 5.5 5.48 5.5m0-4.58c-1.01 0-1.841.82-1.841 1.84a1.842 1.842 0 0 0 3.682 0A1.843 1.843 0 0 0 5.48.92M10.543 11c-.2 0-.39-.13-.44-.34C9.541 8.62 7.65 7.2 5.5 7.2S1.458 8.62.898 10.66c-.07.24-.31.39-.56.32a.46.46 0 0 1-.32-.56c.66-2.43 2.92-4.13 5.482-4.13 2.561 0 4.822 1.7 5.483 4.13.07.24-.08.5-.32.56-.04.01-.08.02-.12.02"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconUser.defaultProps = {
  className: null,
  rootClassName: null,
};

IconUser.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconUser;
